import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import { SeoService } from '@rpgc-ai/services/seo/seo.service';

import type { IPublicProfile } from '@rpgc-ai/shared-interfaces/interfaces/public-profile.interface';

import { catchError, map, of, tap } from 'rxjs';

export const publicProfileSeoResolver: ResolveFn<void> = (route) => {
  const http = inject(HttpClient);
  const seoService = inject(SeoService);

  const profileId = route.params['id'];
  if (!profileId) {
    return;
  }

  return http.get<IPublicProfile>(`profile/${profileId}`).pipe(
    tap((profile) => {
      const title = `${profile.name} | CAICHAT`;
      const description = profile.highlights ?? '';

      seoService.setTitle(title);
      seoService.setTag('description', description, 'name');
      seoService.setTag('og:title', title, 'property');
      seoService.setTag('og:description', description, 'property');
    }),
    map(() => void 0),
    catchError((error: unknown) => {
      // eslint-disable-next-line no-console
      console.error('publicProfileSeoResolver: failed to load public profile SEO data', error);
      return of(void 0);
    }),
  );
};
